// extracted by mini-css-extract-plugin
export default {"card":"rqCLW","hoverShadow":"Tvje8","shadow":"bNTFV","noPadding":"sWEq2","noSidePadding":"xGUoi"};